import { CompoundRuleGroupList, SectionDividerRuleGroup } from '@wix/rules-panel-ui';
import React, { useMemo } from 'react';
import { SiteLevelPageGroup } from '../components/wizard-content/content-results/rule-groups/site-level-group/site-level-page-group';
import { StaticPageGroup } from '../components/wizard-content/content-results/rule-groups/static-page-group/static-page-group';
import { VerticalPageGroup } from '../components/wizard-content/content-results/rule-groups/vertical-page-group/vertical-page-group';
import { SITE_LEVEL_PAGE_ID } from '../consts';
import { usePanelStateAtom } from '../hooks/rules-state';
import { useA11yWizardAdapter } from '../hooks/use-a11y-wizard-adapter';
export const DividedIssuesList = _ref => {
  let {
    nodeRef
  } = _ref;
  const {
    getPagesData
  } = usePanelStateAtom();
  const pagesData = getPagesData();
  const {
    a11yWizardAdapter,
    capabilities
  } = useA11yWizardAdapter();
  const pageGroups = useMemo(() => {
    const sectionMap = new Map();
    const homePageId = a11yWizardAdapter.getHomePageId();
    const orderedPageIds = [...(pagesData.has(SITE_LEVEL_PAGE_ID) ? [SITE_LEVEL_PAGE_ID] : []), ...(homePageId && pagesData.has(homePageId) ? [homePageId] : []), ...Array.from(pagesData.keys()).filter(id => id !== SITE_LEVEL_PAGE_ID && id !== homePageId)];
    orderedPageIds.forEach(pageId => {
      var _sectionMap$get;
      if (pageId === SITE_LEVEL_PAGE_ID) {
        sectionMap.set(pageId, [/*#__PURE__*/React.createElement(SiteLevelPageGroup, {
          key: pageId
        })]);
        return;
      }
      const pageData = pagesData.get(pageId);
      if (!pageData) {
        return;
      }
      const {
        dividerTitle,
        tpaPage
      } = pageData;
      if (!sectionMap.has(dividerTitle)) {
        sectionMap.set(dividerTitle, []);
      }
      const node = tpaPage ? /*#__PURE__*/React.createElement(VerticalPageGroup, {
        key: pageId,
        pageId: pageId
      }) : /*#__PURE__*/React.createElement(StaticPageGroup, {
        key: pageId,
        pageId: pageId
      });
      (_sectionMap$get = sectionMap.get(dividerTitle)) == null || _sectionMap$get.push(node);
    });
    const nodes = [];
    sectionMap.forEach((pages, key) => {
      if (key === SITE_LEVEL_PAGE_ID) {
        nodes.push(...pages);
        return;
      }
      nodes.push(/*#__PURE__*/React.createElement(SectionDividerRuleGroup, {
        backgroundColor: capabilities.wizardPresentation.softIssueListSurfaces ? 'D70' : 'D60',
        groupId: key,
        key: key
      }));
      nodes.push(...pages);
    });
    return nodes;
  }, [pagesData, capabilities.wizardPresentation.softIssueListSurfaces, a11yWizardAdapter]);
  return /*#__PURE__*/React.createElement(CompoundRuleGroupList, {
    hideShadow: capabilities.wizardPresentation.softIssueListSurfaces,
    parentNodeRef: nodeRef
  }, pageGroups);
};
//# sourceMappingURL=divided-issues-list.js.map